import { useCallback } from 'react';

import { useProjectActions } from 'src/store/project';

export const useHandlers = ({ openMenu, closeMenu }) => {
  const projectActions = useProjectActions();

  const handleDropdownClick = useCallback(() => {
    openMenu();
  }, [openMenu]);

  const handleMenuClose = useCallback(() => {
    closeMenu();
  }, [closeMenu]);

  const handleSelectStyle = useCallback(
    (imageStyle) => {
      projectActions.selectImageStyle(imageStyle);
      closeMenu();
    },
    [projectActions, closeMenu]
  );

  return {
    handleDropdownClick,
    handleMenuClose,
    handleSelectStyle,
  };
};
